/***
* Add by lbp
* created:20190805
* 注:商家联盟订单详情
*/
<template>
  <div>
    <div class="order-detail">
      <div class="item-order">
        <img :src="imageUrl + orderData.pic">
        <div class="order-info">
          <span>{{ orderData.activityName }}</span>
          <span>￥{{ orderData.totalMoney }}</span>
        </div>
      </div>
      <div class="order-list" v-for="(item,index) in storeList" :key="index">
        <div class="store-info">
          <span class="store-name">{{ item.name }}</span>
          <div class="address-info">
            <img src="../../resource/img/地址@2x.png"/>
            <span class="address">{{ item.address }}</span>
          </div>
          <div class="phone-info">
            <img src="../../resource/img/电话@2x.png"/>
            <span>{{ item.phone }}</span>
          </div>
        </div>
        <div class="goods-info" v-for="(subItem,subIndex) in item.unionGoodsOrderEntityList" :key="subIndex">
          <span class="name">{{ subItem.goodsName }}</span>
          <div class="goods-num">
            <div class="num-info">
              <span class="title">总数</span>
              <span>{{ subItem.buyNum }}</span>
            </div>
            <div class="num-info">
              <span class="title">已使用</span>
              <span>{{ subItem.useNum }}</span>
            </div>
            <div class="num-info">
              <span class="title">剩余</span>
              <span>{{ subItem.buyNum - subItem.useNum }}</span>
            </div>
            <img class="code-img" src="../../resource/img/two-dime.png" @click="ewmCode(subItem)"/>
          </div>
          <div class="check-item" @click="openUseList(subItem)">
            <span class="title">查看使用记录</span>
            <img src="../../resource/img/device/arrow-right.png">
          </div>
        </div>
      </div>
      <div class="order-other">
        <div class='item-list-div'>
          <span>订单编号</span>
          <span>{{ orderData.orderId }}</span>
        </div>
        <div class='item-list-div'>
          <span>下单时间</span>
          <span>{{ orderData.orderTime }}</span>
        </div>
        <div class='item-list-div'>
          <span>订单总价</span>
          <span>￥{{ orderData.totalMoney }}</span>
        </div>
        <div class='item-list-div'>
          <span>订单状态</span>
          <span v-if="orderData.paid == 1 && orderData.status == 0">待服务</span>
          <span v-if="orderData.paid == 1 && orderData.status == 1">已完成</span>
        </div>
      </div>
      <div class="form-content" v-if="showRecord">
        <div class="titleInfo">
          <div class="title">
            <span>使用记录</span>
            <img class="close-img" src="../../resource/img/gb.png" @click="closeRecord"/>
          </div>
          <div class="use-list">
            <span v-for="(item,index) in useDetailList" :key="index">使用时间:{{ item.useTime }}</span>
          </div>
        </div>
      </div>
      <div class="code-item" v-if="showCode">
        <div class="item">
          <div class="title-div">
            <span>核销二维码</span>
            <img src="../../resource/img/gb.png" @click="closeCode"/>
          </div>
          <div id="qrcode" class="qrcode"></div>
          <p class="bottom-text">生成二维码仅限提供给商家扫描验证消费使用哦~</p>
        </div>
      </div>
      <div class="mask" v-if="showMask"></div>
    </div>
  </div>
</template>

<script>
import {qrcanvas} from 'qrcanvas'
import Toast from '@nutui/nutui/dist/packages/toast/toast'

export default {
  name: 'MerUnionOrderDetail',
  data () {
    return {
      timeId: null,
      data: {},
      orderData: {},
      storeList: [],
      useDetailList: [],
      // imageUrl: sessionStorage.url,
      imageUrl: 'https://files.mbspt.com',
      showMask: false,
      showRecord: false,
      showCode: false,
    }
  },
  created () {
    this.$common.changetitle('订单详情')
    this.data = this.$route.query
    this.getOrderData()
  },
  methods: {
    getOrderData () {
      this.$api.post({
        url: '/merchant/api/merchant/merchant-union-order/find',
        data: {
          activityId: this.data.activityId,
          uid: this.data.uid,
          orderId: this.data.orderId
        },
        login: false
      }).then(res => {
        this.orderData = res.data
        this.getStoreInfoOrderList()
      })
    },
    //查询当前拓客活动所有商户下订单信息
    getStoreInfoOrderList () {
      this.$api.post({
        url: '/merchant/api/merchant/merchant-union-store-info/findOrderList',
        data: {
          ids: this.orderData.unionStoreIds,
          orderId: this.orderData.orderId
        },
        login: false
      }).then(res => {
        this.storeList = res.data
      })
    },
    //生成核销二维码
    ewmCode (item) {
      this.$api.post({
        url: '/merchant/api/activity/merchant-union-order-usedetail/save',
        data: {
          itemsOrderId: item.goodsOrderId,
          orderId: item.orderId,
        },
        login: false
      }).then(res => {
        let useDetailId = res.data.id
        this.showCode = true
        this.showMask = true
        this.$nextTick(() => {
          let url = this.imageUrl + '/wap.php?g=Wap&c=Storestaff&a=mrmf_union_use&id=' + res.data.id
          let canvas = qrcanvas({
            data: decodeURIComponent(url), //分享链接（根据需求来）
            size: 220 //二维码大小
          })
          document.getElementById('qrcode').innerHTML = ''
          document.getElementById('qrcode').appendChild(canvas)
          let timeInt = 10
          this.timeId = setInterval(res => {
            timeInt--
            this.$api.post({
              url: '/merchant/api/activity/merchant-union-order-usedetail/save',
              data: {
                id: useDetailId,
                itemsOrderId: item.goodsOrderId,
                orderId: item.orderId
              },
              loading: false,
            }).then(res => {
              let useDetail = res.data
              if (useDetail.status == 1) {
                window.clearInterval(this.timeId)  //移除定时器
                this.showCode = false
                this.showMask = false
                this.getOrderData()
                Toast.success('核销成功')
              }
            })
            if (timeInt == 0) {
              window.clearInterval(this.timeId)  //移除定时器
            }
          }, 6000)
        })
      }).catch(err => {
        this.getOrderData()
      })
    },
    closeCode () {
      this.showCode = false
      this.showMask = false
      window.clearInterval(this.timeId)  //移除定时器
    },
    openUseList (item) {
      this.$api.post({
        url: '/merchant/api/activity/merchant-union-order-usedetail/list',
        data: {
          itemsOrderId: item.goodsOrderId,
          status: 1
        },
        login: false
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          this.useDetailList = res.data
          this.showRecord = true
          this.showMask = true
        } else {
          Toast.fail('暂无使用记录')
        }
      })
    },
    closeRecord () {
      this.showRecord = false
      this.showMask = false
    }
  },
}
</script>

<style scoped>
.order-detail {
  background-color: #F5F6F8;
  padding: 50px 3vw 3vw 3vw;
  font-size: 15px;
}

.order-detail .item-order {
  display: flex;
  flex-direction: row;
  background: #fff;
  padding: 15px;
  margin-top: 10px;
  border-radius: 10px;
}

.order-detail .item-order > img {
  width: 90px;
  height: 90px;
  border-radius: 10px;
  margin-right: 10px;
}

.order-detail .item-order .order-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 0;
}

.order-detail .order-list {
  display: flex;
  flex-direction: column;
  background: #fff;
  margin-top: 10px;
  border-radius: 10px;
  padding: 15px;
}

.order-detail .order-list .store-info {
  display: flex;
  flex-direction: column;
}

.order-detail .order-list .store-info .store-name {
  font-size: 18px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.order-detail .order-list .store-info .address-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  line-height: 40px;
}

.order-detail .order-list .store-info .address-info > img {
  width: 18px;
  height: 23px;
  margin-right: 5px;
}

.order-detail .order-list .store-info .address-info .address {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.order-detail .order-list .store-info .phone-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  line-height: 40px;
}

.order-detail .order-list .store-info .phone-info > img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.order-detail .order-list .goods-info {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.order-detail .order-list .goods-info .name {
  font-size: 18px;
}

.order-detail .order-list .goods-info .goods-num {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  border-bottom: 1px dashed #BFBFBF;
}

.order-detail .order-list .goods-info .goods-num .num-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.order-detail .order-list .goods-info .goods-num .num-info .title {
  margin-bottom: 5px;
}

.order-detail .order-list .goods-info .goods-num .code-img {
  width: 40px;
  height: 40px;
}

.order-detail .order-list .goods-info .check-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}

.order-detail .order-list .goods-info .check-item > img {
  width: 28px;
  height: 28px;
}

.order-detail .order-list .goods-info .check-item .title {
  margin-right: 5px
}

.order-detail .order-other {
  background: rgba(255, 255, 255, 1);
  padding: 15px;
  margin-top: 10px;
}

.order-detail .order-other .item-list-div {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  justify-content: space-between;
}

.mask {
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
}

.order-detail .form-content {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.order-detail .form-content .titleInfo {
  width: 90%;
  height: 300px;
  position: fixed;
  top: 20%;
  z-index: 3;
  background-color: #ffffff;
  border-radius: 10px;
}

.order-detail .form-content .titleInfo .title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
  background: rgba(248, 248, 248, 1);
  border-radius: 10px;
  font-size: 18px;
  margin-left: 20px;
}

.order-detail .form-content .titleInfo .title > span {
  flex: 1;
  text-align: center;
}

.order-detail .form-content .titleInfo .title .close-img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.order-detail .form-content .titleInfo .use-list {
  display: flex;
  flex-direction: column;
  padding: 15px;
  height: 220px;
  overflow: scroll;
}

.order-detail .form-content .titleInfo .use-list > span {
  height: 30px;
  line-height: 30px;
}

.code-item {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  display: flex;
  justify-content: center;
}

.code-item .item {
  width: 80vw;
  height: 80vw;
  background-color: white;
  margin-top: 45%;
  display: block;
  text-align: center;
}

.code-item .item .title-div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.code-item .item .title-div > span {
  flex: 1;
  margin-left: 50px;
  text-align: center;
}

.code-item .item .title-div > img {
  width: 25px;
  height: 25px;
  margin: 10px;
}

.code-item .item .qrcode {
  display: flex;
  justify-content: center;
}

.code-item .item .qrcode canvas {
  width: 100%;
}

.code-item .item .bottom-text {
  color: rgba(247, 193, 39, 1);
  width: 90%;
  padding: 0 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/active/MerUnionOrderDetail.vue